module.exports = __webpack_public_path__ + "img/badge_welcome_to_italy.602c14d3.jpg";